class EventService {
    /*@ngInject*/
    constructor($timeout) {
        this.$timeout = $timeout;
        this.subscriptions = {};
    }

    broadcast(event, dataObj) {
        if (typeof this.subscriptions[event] === 'undefined') {
            return;
        }
        this.$timeout(function () {
            if(typeof this.subscriptions[event]==='undefined'){
                return;
            }
            this.subscriptions[event].forEach(function (cb) {
                cb(dataObj);
            });
        }.bind(this));
    }

    getUnsubscribe(event, callback) {
        return function () {
            let i = this.subscriptions[event].indexOf(callback);
            if (i !== -1) {
                this.subscriptions[event].splice(i, 1);
                if (this.subscriptions[event].length === 0) {
                    delete this.subscriptions[event];
                }
            }
        };

    }

    subscribe(event, callback) {
        if (typeof this.subscriptions[event] === 'undefined') {
            this.subscriptions[event] = [];
        }
        this.subscriptions[event].push(callback);
        return this.getUnsubscribe(event, callback).bind(this);
    }
}

export default EventService;





// WEBPACK FOOTER //
// ./public/app/services/event.service.js